import React from 'react'
import { csx, cx } from '@vtex/admin-ui'

export type ProductProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>

export const Product = ({
  children,
  className = '',
  ...props
}: ProductProps) => (
  <div
    className={cx(
      csx({
        cursor: 'pointer',
      }),
      className
    )}
    {...props}
  >
    {children}
  </div>
)
